import CardConfig from './CardConfig'
import RowCardConfig from './RowCardConfig'
import HtmlCardConfig from './HtmlCardConfig'

export default {
    'card-config': CardConfig,
    'row-card-config': RowCardConfig,
    'html-card-config': HtmlCardConfig
}
